// ProductDetails.jsx
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { QueryButton } from '../../querybutton';
const productData = {
    categories: [
        {
            id: 'building-hardware',
            name: 'Building & Hardware',
            description: 'Building supplies, timber, fencing and facades',
            image: 'assets/images/banner/01.webp',
            subcategories: [
                {
                    id: 'building-supplies',
                    name: 'Building Supplies',
                    image: 'assets/images/categories/building-supplies.webp',
                    products: [
                        'Concrete Products, Prefabricated Concrete Support Structures',
                        'Driveway & Porcelain Paving',
                        'Block Paving, Pavement Blocks',
                        'Frost And Water Proofers',
                        'Roofing Tiles',
                        'Guttering & Drainage',
                        'Marble Slabs, Stones and Tiles',
                        'Decorative & Rocky Stones',
                        'Waterproof & Weather Resistant Cement'
                    ]
                },
                {
                    id: 'facades-fencing',
                    name: 'Facades and Fencing',
                    image: 'assets/images/categories/fencing.webp',
                    products: [
                        'Window Handles, Fasteners & Stays',
                        'Doors for Home and Industry (Internal, External, Security, Fire Rated, Industrial)',
                        'Windows (Wooden, uPVC, Aluminium)',
                        'Panel Fencing'
                    ]
                }
            ]
        },
        {
            id: 'kitchen-bathroom',
            name: 'Kitchen and Bathroom',
            description: 'Bathroom suites, kitchen appliances and units',
            image: 'assets/images/banner/mk.webp',
            subcategories: [
                {
                    id: 'bathroom-plumbing',
                    name: 'Bathroom and Plumbing',
                    image: 'assets/images/categories/bathroom.webp',
                    products: [
                        'Wastes Traps & Overflow and Kitchen Sinks Accessories',
                        'Pipes, Plumbing Supplies',
                        'Bathroom Decorations And Accessories',
                        'Bathroom Showers, Cubicles And Accessories',
                        'Shower Curtains',
                        'Towels',
                        'Basins',
                        'Toilet Seats',
                        'Tap Fittings and Spares',
                        'Push Fit Waste Fittings',
                        'Bath, Basins & Sink Fittings',
                        'Toilet Repair & Fittings',
                        'Wet Rooms',
                        'Shower Trays',
                        'Shower Screens'
                    ]
                },
                {
                    id: 'bathroom-suite',
                    name: 'Bathroom Suite',
                    image: 'assets/images/categories/bathroom-suite.webp',
                    products: [
                        'Wall Hung Toilet',
                        'Freestanding Baths and Home Spa',
                        'Shower Baths',
                        'Bath Screens'
                    ]
                },
                {
                    id: 'kitchen-appliances',
                    name: 'Kitchen Appliances',
                    image: 'assets/images/categories/kitchen-appliances.webp',
                    products: [
                        'Cooker',
                        'Kitchen Sinks, Stainless Steel Sinks',
                        'Hand Mixers',
                        'Blenders',
                        'Freezer',
                        'Fridge Freezer',
                        'Microwave',
                        'Rice Cooker',
                        'Refrigeration',
                        'Kitchen cooker ovens',
                        'Induction Hobs',
                        'Gas Hobs',
                        'Cooker Hoods'
                    ]
                },
                {
                    id: 'kitchen-units',
                    name: 'Kitchens',
                    image: 'assets/images/categories/kitchen.webp',
                    products: [
                        'Kitchen Units And Cabinets',
                        'Complete Kitchen Units Supply',
                        'Solid Wood Worktops Retail and Supply',
                        'Laminate Worktops',
                        'Kitchen Worktops and Surfaces',
                        'Kitchen Flooring',
                        'Kitchen Cabinets Handles',
                        'Kitchen laundry'
                    ]
                }
            ]
        },
        {
            id: 'home-bedrooms',
            name: 'Home and Bedrooms',
            description: 'Furniture, appliances and furnishings',
            image: 'assets/images/categories/home-furniture.webp',
            subcategories: [
                {
                    id: 'home-furniture',
                    name: 'Home Furniture',
                    image: 'assets/images/categories/furniture.webp',
                    products: [
                        'Bed And Mattress',
                        'Bedside Table',
                        'Sofa',
                        'Wardrobe'
                    ]
                },
                {
                    id: 'home-furnishing',
                    name: 'Home Furnishing',
                    image: 'assets/images/categories/furnishing.webp',
                    products: [
                        'Wall Art And Pictures',
                        'Clocks And Home Accessories',
                        'Curtain Pole Hanging Brackets',
                        'Curtain Tracks',
                        'Curtain Poles & Tracks',
                        'Curtains, Blinds & Shutters'
                    ]
                },
                {
                    id: 'cooking-dining',
                    name: 'Cooking and Dining',
                    image: 'assets/images/categories/dining.webp',
                    products: [
                        'Dinner Sets, Bowls, Cutlery and Dinner Plate Sets',
                        'Drinkware, drinking cups & wine glasses for Special Occasions',
                        'Cookware, Saucepans, Frying Pans For Homes and Food Business'
                    ]
                }
            ]
        },
        {
            id: 'mep',
            name: 'MEP (Mechanical, Electrical, Plumbing)',
            description: 'Lighting, electricals and plumbing systems',
            image: 'assets/images/categories/mep.webp',
            subcategories: [
                {
                    id: 'mechanical',
                    name: 'Mechanical',
                    image: 'assets/images/categories/mechanical.webp',
                    products: [
                        'Fans and Extractors',
                        'HVAC',
                        'Heaters',
                        'Air Conditioners and Cooling Systems',
                        'Ventilators and grilles'
                    ]
                },
                {
                    id: 'electrical-lighting',
                    name: 'Electricals and Lighting',
                    image: 'assets/images/categories/electrical.webp',
                    products: [
                        'Standard Electrical Installation',
                        'Advanced Electrical Installation',
                        'Connected Smart Installation',
                        'Integrated Automation Systems',
                        'Fixings & Plugs',
                        'Fans',
                        'Home Wiring Cables',
                        'Standard Extension Leads',
                        'Extension Leads, Cable Reels',
                        'Sockets, Plugs & Electrical Fittings',
                        'Lighting, Fixtures, And Fittings',
                        'Cable Management'
                    ]
                },
                {
                    id: 'lights',
                    name: 'Lights',
                    image: 'assets/images/categories/lighting.webp',
                    products: [
                        'Indoor range (Downlights, Projectors, Ceiling, Linear systems, etc)',
                        'Outdoor range (Ceiling lamps, Wall lamps, Bollards & poles, etc)',
                        'Flex Light range',
                        'Electronic range',
                        'Decorative Lights',
                        'Streetlights'
                    ]
                },
                {
                    id: 'plumbing',
                    name: 'Plumbing',
                    image: 'assets/images/categories/plumbing.webp',
                    products: [
                        'Plumbing fixtures and systems'
                    ]
                }
            ]
        },
        {
            id: 'tools-equipment',
            name: 'Tools and Equipment',
            description: 'Hand tools, power tools and equipment',
            image: 'assets/images/categories/tools.webp',
            subcategories: [
                {
                    id: 'hand-tools',
                    name: 'Hand Tools',
                    image: 'assets/images/categories/hand-tools.webp',
                    products: [
                        'Hammers, Crowbars And Axes',
                        'Screwdrivers',
                        'Chisels',
                        'Wire Brushes',
                        'Breakers & Demolition Tools',
                        'Tape Measure',
                        'Bricklaying Tools',
                        'Nail Guns',
                        'Vice & Clamp',
                        'Hand Saws',
                        'Hex Keys',
                        'Electrical Tester',
                        'Soldering Iron',
                        'Blow Torches'
                    ]
                },
                {
                    id: 'equipment',
                    name: 'Equipment',
                    image: 'assets/images/categories/equipment.webp',
                    products: [
                        'Brackets',
                        'Nails',
                        'Sandpaper',
                        'Workshop Machinery',
                        'Sawing & Blades Drill Accessories',
                        'Hole Saws',
                        'Ladders and Steps',
                        'Step Ladders',
                        'Step Stools, Step Ups Ladders',
                        'Work Platforms'
                    ]
                },
                {
                    id: 'power-tools',
                    name: 'Power Tools',
                    image: 'assets/images/categories/power-tools.webp',
                    products: [
                        'Drills (Combi, Hammer, SDS, Angle)',
                        'Saws (Circular, Jig, Reciprocating)',
                        'Angle Grinders',
                        'Planers',
                        'Routers',
                        'Sanders',
                        'Electric Screwdrivers',
                        'Impact Drivers & Wrenches'
                    ]
                },
                {
                    id: 'power-tool-accessories',
                    name: 'Power Tools Accessories',
                    image: 'assets/images/categories/tool-accessories.webp',
                    products: [
                        'Drilling Sets',
                        'Drilling Bits',
                        'Screwdriver Bits',
                        'Power & Accessories',
                        'Jigsaw Blade',
                        'Wood Drill Bits',
                        'Specialist Drill Bits & Accessories',
                        'Core Drill Bits'
                    ]
                },
                {
                    id: 'tiling-tools',
                    name: 'Tiling Tools and Accessories',
                    image: 'assets/images/categories/tiling-tools.webp',
                    products: [
                        'Tile Spacer',
                        'Tile Cutter',
                        'Tiling Tools'
                    ]
                },
                {
                    id: 'measure-tools',
                    name: 'Measure and Level Tools',
                    image: 'assets/images/categories/measure-tools.webp',
                    products: [
                        'Tape Measure',
                        'Spirit Levels',
                        'Laser Levels',
                        'Measure Level Tools'
                    ]
                }
            ]
        },
        {
            id: 'outdoor-garden',
            name: 'Outdoor, Garden and Public Space',
            description: 'Garden tools, furniture and outdoor items',
            image: 'assets/images/categories/garden.webp',
            subcategories: [
                {
                    id: 'outdoor-garden',
                    name: 'Outdoor and Garden',
                    image: 'assets/images/categories/outdoor.webp',
                    products: [
                        'Garden Power Tools',
                        'Garden Furniture',
                        'Garden Dining Set',
                        'Garden Sofa',
                        'Garden Furniture, Chairs, Sofas and Patio Sets'
                    ]
                }
            ]
        },
        {
            id: 'tiling-flooring',
            name: 'Tiling and Flooring',
            description: 'Flooring options, tiles and accessories',
            image: 'assets/images/categories/flooring.webp',
            subcategories: [
                {
                    id: 'flooring',
                    name: 'Flooring',
                    image: 'assets/images/categories/floor-materials.webp',
                    products: [
                        'Laminate Flooring',
                        'Real Wood Top Layer Flooring',
                        'Epoxy Flooring'
                    ]
                },
                {
                    id: 'tiles',
                    name: 'Tiles',
                    image: 'assets/images/categories/tiles.webp',
                    products: [
                        'Vinyl Flooring',
                        'Vinyl Floating Flooring',
                        'Carpet Tiles',
                        'Floor Tiles',
                        'Wall Cladding',
                        'Decorative Wall and Floor Tiles',
                        'Patterned Tiles',
                        'Mosaic Wall and Floor Tiles',
                        'Porcelain Tiles',
                        'Grout',
                        'Architectural Ceramics'
                    ]
                },
                {
                    id: 'flooring-accessories',
                    name: 'Accessories and Tools',
                    image: 'assets/images/categories/flooring-tools.webp',
                    products: [
                        'Flooring and Tiling Supplies',
                        'Tiling Adhesives',
                        'Tile Sealants',
                        'Scotias and Floor Trims',
                        'PVC Cladding',
                        'Grouts'
                    ]
                }
            ]
        },
        {
            id: 'painting-decoration',
            name: 'Painting and Decoration',
            description: 'Paints, treatments and decorating tools',
            image: 'assets/images/categories/painting.webp',
            subcategories: [
                {
                    id: 'paint-treatment',
                    name: 'Paint and Wood treatment',
                    image: 'assets/images/categories/paint.webp',
                    products: [
                        'Paint',
                        'Masonry Paint',
                        'Interior Emulsion Paint',
                        'Metal Paint',
                        'Spray Paint',
                        'Specialist Paint & Treatment',
                        'Primers & Undercoats',
                        'Paint Solvents and Thinners',
                        'Marine Coats',
                        'Surface preparation and Pre-treatments'
                    ]
                },
                {
                    id: 'decorating-tools',
                    name: 'Decorating Tools and Supplies',
                    image: 'assets/images/categories/painting-tools.webp',
                    products: [
                        'Paint Brushes & Sprayers',
                        'Tapes',
                        'Paint Rollers',
                        'Knives & Scrappers',
                        'Knives & Cutters',
                        'Scuttles',
                        'Paint Rollers, Pads, Sleeves, Trays & Poles'
                    ]
                }
            ]
        },
        {
            id: 'ceiling-cladding',
            name: 'Ceiling, Claddings & Partitioning',
            description: 'Plaster products and ceiling materials',
            image: 'assets/images/categories/ceiling.webp',
            subcategories: [
                {
                    id: 'ceiling-materials',
                    name: 'Ceiling Materials',
                    image: 'assets/images/categories/ceiling-materials.webp',
                    products: [
                        'Plaster Products',
                        'Plasterboard',
                        'Plasterboard Fixing and Screws',
                        'POP or White Cement',
                        'Ceiling Tiles'
                    ]
                }
            ]
        },
        {
            id: 'screws-fittings',
            name: 'Screws, Nails and Fittings',
            description: 'Fasteners, hardware and accessories',
            image: 'assets/images/categories/hardware.webp',
            subcategories: [
                {
                    id: 'screws',
                    name: 'Screws',
                    image: 'assets/images/categories/screws.webp',
                    products: [
                        'Screws Trade Packs',
                        'Wood Screws',
                        'Decking Screws',
                        'Timber Screws',
                        'Drywall Screws',
                        'Stainless Steel Screws',
                        'Self-Tapping and Drilling Screws',
                        'Masonry, Concrete Screws',
                        'Machine Screws',
                        'Electrical Screws',
                        'Security Screws',
                        'Flooring Screws',
                        'Screws Caps'
                    ]
                },
                {
                    id: 'fixers-fasteners',
                    name: 'Fixers and Fasteners',
                    image: 'assets/images/categories/fasteners.webp',
                    products: [
                        'Wall Plugs',
                        'Frame and Hammer Fixings',
                        'Heavy Duty Screw Fixings & Rivets',
                        'Hooks & Eyes fixings',
                        'Parkers and Shims Fixings',
                        'Plasterboard Fixings',
                        'Resin Fixings',
                        'Cavity Fixings',
                        'Hose and Tool Clips',
                        'Mirrors and Picture Fittings'
                    ]
                },
                {
                    id: 'nails',
                    name: 'Nails',
                    image: 'assets/images/categories/nails.webp',
                    products: [
                        'Bright Nails',
                        'Galvanised Nails',
                        'Masonry Nails',
                        'Collated Nails'
                    ]
                },
                {
                    id: 'hardware-accessories',
                    name: 'Hardware Accessories',
                    image: 'assets/images/categories/hardware-accessories.webp',
                    products: [
                        'Door Handles',
                        'Hinges and Bolts',
                        'Cylinders',
                        'Locks',
                        'Multipoint Locks',
                        'Key Management Systems',
                        'Closers',
                        'Stoppers',
                        'Sliding Systems',
                        'Window and Door Hardware'
                    ]
                }
            ]
        },
        {
            id: 'finishes-decoration',
            name: 'Finishes and Decoration',
            description: 'Interior and exterior finishing solutions',
            image: 'assets/images/categories/finishes.webp',
            subcategories: [
                {
                    id: 'finishes-solutions',
                    name: 'Finishes Solutions',
                    image: 'assets/images/categories/finishing-solutions.webp',
                    products: [
                        'Interior Finishes',
                        'Exterior Finishes',
                        'Technical and Decorative Profiles',
                        'Expansion Joints',
                        'Technical Entrance Mats',
                        'Universal Accessibility and Safety Solutions'
                    ]
                }
            ]
        },
        {
            id: 'construction-chemicals',
            name: 'Construction Chemicals',
            description: 'Specialty chemicals for construction',
            image: 'assets/images/categories/chemicals.webp',
            subcategories: [
                {
                    id: 'chemical-solutions',
                    name: 'Chemical Solutions',
                    image: 'assets/images/categories/construction-chemicals.webp',
                    products: [
                        'Waterproofing',
                        'Sealants',
                        'Concrete Admixtures',
                        'Adhesives',
                        'Coating',
                        'Polymer Bonding Agents',
                        'Repair and Rehabilitation',
                        'Concrete Curing Compounds',
                        'Retarder',
                        'Accelerators',
                        'Mortar additives',
                        'Mould releasing agents',
                        'Concrete hardeners',
                        'Plasticizers',
                        'Flooring compounds',
                        'Superplasticizers',
                        'Cementitious materials',
                        'Epoxy',
                        'Air-entraining',
                        'Green Construction Chemicals'
                    ]
                }
            ]
        }
    ]
};



const ProductDetails = () => {
    const { categoryId, subcategoryId, productName } = useParams();
    const decodedProductName = decodeURIComponent(productName);

    // Find the product in our data structure
    const category = productData.categories.find(cat => cat.id === "construction-chemicals");
    const subcategory = category?.subcategories.find(sub => sub.id === "chemical-solutions");
    const product = subcategory?.products.find(p => p === decodedProductName);

    if (!category || !subcategory || !product) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">Product Not Found</h1>
                    <Link to="/" className="text-blue-600 hover:text-blue-800">
                        ← Back to Home
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">


            {/* Header */}
            <header className="bg-[#00a3A1] text-white shadow-md">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center">
                        <Link to={`/products/${categoryId}/${subcategoryId}`} className="mr-2 text-white hover:text-gray-200">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </Link>
                        <h1 className="text-2xl font-bold">Product Details</h1>
                    </div>
                </div>
            </header>
            {/* Main Content */}
            <main className="container mx-auto px-4 py-2">
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                    {/* Product Header */}
                    <div className="relative h-64 w-full bg-gray-200">
                        <img
                            src="../assets/images/banner/04.jpg"
                            alt={decodedProductName}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                            <h2 className="text-3xl font-bold text-white text-center px-4">{decodedProductName}</h2>
                        </div>
                    </div>

                    {/* Product Details */}
                    <div className="p-6 md:p-8">
                        <div className="flex flex-col md:flex-row gap-8">
                            {/* Left Column - Product Info */}
                            <div className="md:w-2/3">
                                <div className="mb-3">
                                    <h3 className="text-xl font-semibold mb-2">Product Description</h3>
                                    <p className="text-gray-600">
                                        High-quality {decodedProductName.toLowerCase()} for professional and home use. Designed for durability and performance.
                                    </p>
                                </div>

                                <div className="mb-3">
                                    <h3 className="text-xl font-semibold mb-2">Specifications</h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        <div>
                                            <h4 className="font-medium text-gray-700">Category</h4>
                                            <p className="text-gray-600">{category.name}</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-gray-700">Subcategory</h4>
                                            <p className="text-gray-600">{subcategory.name}</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-gray-700">Material</h4>
                                            <p className="text-gray-600">Premium grade materials</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-gray-700">Warranty</h4>
                                            <p className="text-gray-600">2 years manufacturer warranty</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <h3 className="text-xl font-semibold mb-2">Features</h3>
                                    <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                        <li>High-performance design</li>
                                        <li>Durable construction</li>
                                        <li>Ergonomic handling</li>
                                        <li>Safety certified</li>
                                        <li>Easy to maintain</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Right Column - Order Info */}
                            <div className="md:w-1/3">
                                <div className="bg-gray-50 rounded-lg p-6 border border-gray-200 sticky top-4">
                                    <div className="flex items-center justify-between mb-4">
                                        <span className="text-2xl font-bold text-gray-800">$99.99</span>
                                        <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">In Stock</span>
                                    </div>

                                    <div className="mb-3">
                                        <div className="flex items-center mb-2">
                                            <img
                                                src="assets/images/service/Rectangle 13.svg"
                                                alt="Delivery"
                                                className="w-6 h-6 mr-2"
                                            />
                                            <span className="text-gray-700">Free delivery on orders over $50</span>
                                        </div>
                                        <div className="flex items-center">
                                            <img
                                                src="assets/images/service/01.webp"
                                                alt="Returns"
                                                className="w-6 h-6 mr-2"
                                            />
                                            <span className="text-gray-700">30-day easy returns</span>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <button className="w-full bg-[#00A3A1] text-white py-3 px-4 rounded-md hover:bg-teal-700 transition font-medium">
                                            Add to Cart
                                        </button>
                                        <button className="w-full bg-white border border-[#00A3A1] text-[#00A3A1] py-3 px-4 rounded-md hover:bg-teal-50 transition font-medium">
                                            Add to Wishlist
                                        </button>
                                    </div>

                                    <div className="mt-6 pt-6 border-t border-gray-200">
                                        <h4 className="font-medium text-gray-700 mb-2">Need help?</h4>
                                        <p className="text-sm text-gray-600">
                                            Contact our customer support for assistance with this product.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Related Products */}
                        <div className="mt-12">
                            <h3 className="text-xl font-semibold mb-6">Related Products</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {subcategory.products.slice(0, 3).map((relatedProduct, index) => (
                                    <div key={index} className="border rounded-lg overflow-hidden hover:shadow-md transition">
                                        <div className="h-48 bg-gray-200 relative">
                                            <img
                                                src="../assets/images/banner/04.jpg"
                                                alt={relatedProduct}
                                                className="absolute inset-0 w-full h-full object-cover"
                                            />
                                        </div>
                                        <div className="p-4">
                                            <h4 className="font-medium text-gray-800 mb-2">{relatedProduct}</h4>
                                            <div className="flex justify-between items-center">
                                                <span className="text-[#00A3A1] font-medium">$89.99</span>
                                                <Link
                                                    to={`/products/${categoryId}/${subcategoryId}/${encodeURIComponent(relatedProduct)}`}
                                                    className="text-sm text-blue-600 hover:text-blue-800"
                                                >
                                                    View →
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-gray-800 text-white py-8">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="mb-4 md:mb-0">
                            <h3 className="text-xl font-bold">Construction Products</h3>
                            <p className="text-gray-400">Quality materials for all your construction needs</p>
                        </div>
                        <div className="flex space-x-4">
                            <a href="#" className="hover:text-[#00A3A1] transition">Terms</a>
                            <a href="#" className="hover:text-[#00A3A1] transition">Privacy</a>
                            <a href="#" className="hover:text-[#00A3A1] transition">Contact</a>
                        </div>
                    </div>
                </div>
            </footer>
            <QueryButton />

        </div>
    );
};

export default ProductDetails;